/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { Suspense, lazy, useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import NavigationBar from "../NavigationBar/NavigationBar";
import { isMobileDevice } from "../Utils";

const BorrowerLeadGenerationTool = lazy(() => import("../ContactForm"));
const Footer = lazy(() => import("../Footer"));

const Layout = ({ children, isMobileDevice }) => {
    const [showOtherComponents, setShowOtherComponents] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            const windowHeight = window.innerHeight;
            const documentHeight = document.body.offsetHeight;
            const scrollPosition =
                window.scrollY ||
                window.pageYOffset ||
                document.documentElement.scrollTop;
            const maxScroll = documentHeight - windowHeight;
            const percentage = (scrollPosition / maxScroll) * 100;

            if (percentage > 20) {
                setShowOtherComponents(true);
            }
        };

        window.addEventListener("scroll", handleScroll);

        // Clean up the scroll listener when the component unmounts
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []); // Empty dependency array ensures the effect runs only once, like componentDidMount
    return (
        <Container
            fluid
            className="container-bg ps-0 pe-0"
        >
            <NavigationBar />
            {children}
            {showOtherComponents && (
                <>
                    <Suspense fallback={<div />}>
                        <BorrowerLeadGenerationTool isMobileDevice={isMobileDevice} domainNameConsent="swmc.com"
                            language="en" />
                        <Suspense fallback={<div />}>
                            <Footer />
                        </Suspense>
                    </Suspense>
                </>
            )}
        </Container>
    );
};

export default Layout;
